<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-radio-group
        :value="innerValue"
        :readonly="readonly"
        :error-messages="errors"
        @change="change">
      <template v-slot:label>
        <div>
          <v-icon
              v-if="required"
              small
              left
              :color="requiredColor">
            *
          </v-icon>
          {{ label }}
        </div>
      </template>
      <v-radio
          v-for="(item, key) in items"
          :id="`radio-${key}`"
          :key="key"
          v-test="{ 'radio-item': key }"
          :value="key">
        <template v-slot:label>
          <v-tooltip v-if="itemsTips[key]" bottom>
            <template v-slot:activator="data">
              <span v-on="data.on">
                {{ $t(item) }}
              </span>
            </template>
            <span>
              {{ itemsTips[key] || '' }}
            </span>
          </v-tooltip>
          <span v-else>
            {{ $t(item) }}
          </span>
        </template>
      </v-radio>
    </v-radio-group>
  </ValidationProvider>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: null
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      items: {
        type: Object
      },
      itemsTips: {
        type: Object,
        default: () => {
          return {}
        }
      },
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      type: {
        type: String,
        default: 'text'
      },
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        innerValue: null

      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      }
      // innerValue (val) {
      //   this.$emit('input', val)
      // }
    },
    methods: {
      change: function (value) {
        this.$emit('input', value)
        if (this.value !== value) {
          this.$emit('change', value)
        }
      }
    }
  }
</script>
